import React, {useEffect, useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import { SearchOptionItems } from './SearchOptionItems'
import { DeleteListOption } from './DeleteListOption'
import OptionsForm from "./OptionsForm";
import {connect, useDispatch} from "react-redux";
import * as rest from "../../services";
import {showErrorToast, showSuccessToast} from "../../state/toasts";
import {Slider} from "../../components";

export const OptionsDataGrid = ({
  results,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
  listTypes,
  onRefresh,
}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const dispatch = useDispatch()
  const handleUpdate = (data) => {


    const promise = new rest.ListService(data.url).makePatchRequest(data)
    promise
      .then((response) => {
       dispatch(showSuccessToast("Success","Option Updated Successfully."))
        onRefresh()
      })
      .catch((errors) => {
    dispatch(showErrorToast("Error","Could not Update."))
      }).finally(()=>{
        setSelectedItem(null)
    })
  }


  const actionFormatter = (cell, row, rowIndex, formatExtraData) => {

    return (
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle
          variant="dark"
          size="sm"
        ></ReactBootstrap.Dropdown.Toggle>
        <ReactBootstrap.Dropdown.Menu>
          <DeleteListOption item={row} onDelete={onFilter} />

              <ReactBootstrap.Dropdown.Item variant="dark" eventKey="1" onClick={()=>setSelectedItem(row)}>
          {components.ICONS.EDIT} Edit
        </ReactBootstrap.Dropdown.Item>
             </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    )
  }

  const columns = [
    {
      dataField: 'list_name',
      text: 'List Name',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'select',
      options: listTypes,
    },
    {
      dataField: 'value',
      text: 'Value',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
      {
      dataField: 'code',
      text: 'Code',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
      {
      dataField: 'description',
      text: 'Description',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    }, {
      dataField: 'created_by_name',
      text: 'Created By',
      type: 'string',
      formatter: components.CellTextFormatter
    },

    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },
          {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
    {
      dataField: '',
      text: '',
      formatter: actionFormatter,
    },
  ]
   const OptionsFormWithData = connect((state) => ({
    initialValues: { ...selectedItem }, // pull initial values from account reducer
  }))(OptionsForm)
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Options</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <SearchOptionItems
              columns={columns}
              onFilter={onFilter}
              title="Search Options"
            />
            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        {selectedItem && <Slider open={selectedItem}>
          <OptionsFormWithData editMode={true} onSubmit={handleUpdate}/>

        </Slider>}
        <components.DataGrid
          keyField="url"
          data={results || []}
          sizePerPage={page_size || 10}
          current={current || 1}
          columns={columns}
          page={current}
          count={count || 0}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
